<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar
      id="toolbarId_bc15"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
        <el-button v-if="!parentData.isDetail" @click="funcAdd">
          新增
        </el-button>
        <el-button @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      class="mytable-style"
      :cell-class-name="cellClassName"
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column>
        <vxe-table-column
          field="authStatusExt"
          title="审核状态"
          min-width="130"
          :formatter="formatterAuthStatus"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatusExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverType"
          :formatter="formatterDriverType"
          title="实际承运人类型"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.driverType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in driverTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="驾驶员姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="联系方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.phone" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseNumber"
          title="车辆牌照号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicenseNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="identificationNumber"
          title="身份证号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.identificationNumber"
            placeholder="请输入身份证号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLoadWeight"
          title="核定载质量/准牵引总质量(Kg)"
          min-width="240"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.vehicleLoadWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.vehicleLoadWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="idCardDueDate"
          min-width="420"
          title="身份证到期日期"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange1"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'idCardDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverLicenseDueDate"
          title="驾驶证到期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'driverLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="workLicenseDueDate"
          title="道路运输从业资格证到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange2"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'workLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="注册时间"
          min-width="420px"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="代收协议">
        <vxe-table-column
          field="collectionStartTime"
          title="开始时间"
          width="160"
        />
        <vxe-table-column
          field="collectionEndTime"
          title="终止时间"
          width="160"
        />
        <vxe-table-column field="collection" title="状态" width="80">
          <template v-slot="{ row }">
            <template v-if="row.collection == 1">
              已同意
            </template>
            <template v-else>
              <span style="color: red;">待授权</span>
            </template>
          </template>
        </vxe-table-column>
        <vxe-table-column field="collection" title="详细" width="60">
          <template v-slot="{ row }">
            <el-tooltip
              v-if="row.collection == 1"
              class="item"
              effect="dark"
              content="查看"
              placement="top"
            >
              <vxe-button
                type="text"
                @click="showCollectionAgreementModel(row.acceptCode)"
              >
                <em class="el-icon-view" />
              </vxe-button>
            </el-tooltip>
          </template>
        </vxe-table-column>
      </vxe-table-column>
      <vxe-table-column
        v-if="!parentData.isDetail"
        title="操作"
        min-width="360"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="scope.row.driverType === 0"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDetail(scope.row.code, 'detail')"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('driverManage_RealName_button') &&
                (!scope.row.verifyFlagImg || scope.row.verifyFlagImg != 1) &&
                verifyType == 2
            "
            class="item"
            effect="dark"
            content="实名认证"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="toRealName(scope.row.partyCode, scope.row.peopleImg)"
            >
              <em class="el-icon-user-solid" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            :hidden="scope.row.driverType === 0"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <em class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="funcDelete(scope.row.partyCode)">
              <em class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <template>
            <el-tooltip
              v-if="
                scope.row.authStatusExt === 3 && scope.row.isFreezeExt === 0
              "
              :hidden="scope.row.driverType === 0"
              class="item"
              effect="dark"
              content="冻结"
              placement="top"
            >
              <vxe-button type="text" @click="funcLock(scope.row)">
                <em class="el-icon-lock" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.isFreezeExt === 1"
              :hidden="scope.row.driverType === 0"
              class="item"
              effect="dark"
              content="解冻"
              placement="top"
            >
              <vxe-button type="text" @click="funcUnlock(scope.row)">
                <em class="el-icon-unlock" />
              </vxe-button>
            </el-tooltip>
          </template>
          <template v-if="scope.row.isFreezeExt === 0">
            <el-tooltip
              v-if="scope.row.authStatusExt === 3 && scope.row.bindStatus === 1"
              :hidden="scope.row.driverType === 0"
              class="item"
              effect="dark"
              content="绑定车辆"
              placement="top"
            >
              <vxe-button type="text" @click="funcBind(scope.row)">
                <em class="el-icon-link" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.bindStatus != 1"
              :hidden="scope.row.driverType === 0"
              class="item"
              effect="dark"
              content="解绑车辆"
              placement="top"
            >
              <vxe-button type="text" @click="funcUnbind(scope.row)">
                <em class="el-icon-paperclip" />
              </vxe-button>
            </el-tooltip>
          </template>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="1180"
      height="800"
      resize
    >
      <compAdd
        ref="addRef"
        :parent-data="parentData"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="1180"
      height="800"
      resize
    >
      <compEdit
        ref="editRef"
        :parent-data="parentData"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelBindFlag"
      title="绑定车辆"
      width="600"
      height="400"
      resize
    >
      <compBind
        ref="bindRef"
        :parent-data="parentData"
        @fatherBindMethod="fatherBind"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="collectionAgreementFlag"
      title="代收协议"
      width="800"
      height="800"
    >
      <collectionAgreement
        ref="collectionAgreementRef"
        action-path="old"
        @hideModel="hideCollectionAgreementModel"
      />
    </vxe-modal>
    <realName ref="realNameRef" @onSuccess="hideModel" />
    <downloadData ref="downloadRef" />
    <!-- 详情  详情-->
    <vxe-modal
      v-model="driverFlag"
      title="详情"
      width="1400"
      height="800"
      resize
    >
      <driverDetail ref="detailRef" :parent-data="detailParentData" />
    </vxe-modal>
  </div>
</template>
<script>
import compAdd from "./components/teamDirverAdd.vue";
import compEdit from "./components/teamDirverEdit.vue";
import compBind from "./components/teamDirverBind.vue";
import realName from "./components/realName.vue";
import {
  getTeamDriverList,
  batchDelFromTeam,
  freezeTeamDriver,
  unfreezeTeamDriver,
  unbindVehicle,
  verifyIdentityOnOff
} from "@/api/driver";
import collectionAgreement from "../../../driverManage/components/vehicleTeam/collectionAgreement.vue";
import driverDetail from "@/views/tms/review/carrierReview/components/driverDetail.vue";
import { getListDict } from "@/api/commonApi";
export default {
  name: "TeamDriverList",
  components: {
    compAdd,
    compEdit,
    compBind,
    collectionAgreement,
    realName,
    driverDetail
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false,
          areaOptions: [],
          vehicleBindList: [],
          vehicleTypeAllowList: [],
          vehicleClassificationList: [],
          vehicleLengthList: [],
          vehicleWidthList: [],
          vehicleHighList: [],
          vehicleTonnageList: [],
          locationSourceList: [],
          vehicleLicenseColorList: [],
          vehicleEnergyTypeList: []
        };
      }
    }
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/driver/exportTeamDriverList", //导出接口
        name: "车队实际承运人"
      },
      detailParentData: {},
      collectionAgreementFlag: false,
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelBindFlag: false,
      driverFlag: false,
      listQuery: {
        driverLicenseDueDateRange: "",
        driverLicenseDueDateRange1: "",
        driverLicenseDueDateRange2: "",
        gmtCreatedRange: "",
        teamCode: "",
        authStatus: "",
        authStatusExt: "",
        name: "",
        phone: "",
        vehicleLicenseNumber: "",
        identificationNumber: "",
        vehicleLoadWeightCode: "",
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        branchCodeExt: this.$store.state.user.party.branchCode
      },
      sumObject: {
        balance: 0
      },
      authStatusOptions: [
        { label: "未审核", value: 0, color: "gray" },
        // { label: "审核中", value: 1, color: "#0000ff" },
        { label: "审核未通过", value: 2, color: "#ff0000" },
        { label: "审核通过", value: 3, color: "#00bd93" }
      ],
      // 实际承运人/车队类型
      driverTypeOptions: [
        {
          label: "独立实际承运人",
          value: 0
        },
        {
          label: "车队",
          value: 1
        },
        {
          label: "车队实际承运人",
          value: 2
        }
      ],
      // 是否顶级机构，只有顶级机构可以对车队增删改
      isTopBranch: false,
      // 认证类型
      verifyType: 0
    };
  },
  created() {
    this.listQuery.teamCode = this.$route.query.partyCode
      ? this.$route.query.partyCode
      : "";
    // this.findList();
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    this.isTopBranch = dataBranch.level == 0;
    verifyIdentityOnOff({ branchCode: dataBranch.code }).then(response => {
      this.verifyType = response.data.toVerifyIdentity;
    });
    this.detailParentData = JSON.parse(JSON.stringify(this.parentData));
    this.detailParentData.isDetail = true;
    // 获取数据字典： 准驾车型，车型，车长，车宽，车高，吨位，定位来源，能源类型，颜色
    getListDict({ types: "vehicleEnergyType,vehicleLicenseColor" }).then(
      response => {
        this.detailParentData.vehicleEnergyTypeList = response.data.filter(
          item => item.type === "vehicleEnergyType"
        )[0]["dictList"];
        this.detailParentData.vehicleLicenseColorList = response.data.filter(
          item => item.type === "vehicleLicenseColor"
        )[0]["dictList"];
      }
    );
  },
  methods: {
    // 实名认证
    toRealName(partyCode, peopleImg) {
      const checkedRowArray = this.$refs.xTable.getCheckboxRecords();
      this.$refs.xTable.clearCheckboxRow();
      let code = "";
      if (checkedRowArray.length == 1) {
        code = checkedRowArray[0];
      } else if (partyCode) {
        code = partyCode;
      } else {
        return this.$message.warning("请选择一个要实名认证的实际承运人！");
      }
      this.$refs.realNameRef.show(code, peopleImg);
    },
    // 设置重量小数点后三位
    setkey(value, key) {
      this.$set(this.listQuery, key, value.replace(/\.[0-9]+/, ""));
    },
    showCollectionAgreementModel(code) {
      this.collectionAgreementFlag = true;
      this.$refs.collectionAgreementRef.init(code);
    },
    hideCollectionAgreementModel() {
      this.collectionAgreementFlag = false;
    },
    // 类型筛选
    formatterDriverType({ cellValue }) {
      let item = this.driverTypeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getTeamDriverList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 隐藏弹框
    hideModel() {
      this.modelImportFlag = false;
      this.findList();
    },
    funcAdd() {
      this.$refs.addRef.$refs.form.resetFields();
      this.$refs.addRef.resetDueDate();
      this.modelAddFlag = true;
    },
    funcEdit(code) {
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    // 详情
    funcDetail(code, prefix) {
      this.driverFlag = true;
      this.$refs.detailRef.getDriver(code);
    },
    funcDelete(codes) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          batchDelFromTeam({ codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    funcLock(row) {
      this.$confirm("确认冻结吗？")
        .then(_ => {
          freezeTeamDriver({ partyCode: row.partyCode }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    funcUnlock(row) {
      this.$confirm("确认解冻吗？")
        .then(_ => {
          unfreezeTeamDriver({ partyCode: row.partyCode }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    funcBind(row) {
      this.$refs.bindRef.getInfo(row);
      this.modelBindFlag = true;
    },
    funcUnbind(row) {
      this.$confirm("确认解绑吗？")
        .then(_ => {
          unbindVehicle({
            vehicleCode: row.vehicleCode,
            partyCode: row.partyCode
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    fatherBind() {
      this.modelBindFlag = false;
      this.findList();
    },
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "bind":
          this.modelBindFlag = false;
          break;
      }
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      //实际承运人驾驶证提示标红
      if (column.property === "driverLicenseDueDate") {
        if (
          row.driverLicenseDueDate &&
          this.$XEUtils.timestamp(row.driverLicenseDueDate) <=
            new Date().setMonth(new Date().getMonth() + 1)
        ) {
          return "col-red";
        } else if (row.age === 26) {
          return "col-orange";
        }
      }
      //从业资格证到期日期
      if (column.property === "workLicenseDueDate") {
        if (
          row.workLicenseDueDate &&
          this.$XEUtils.timestamp(row.workLicenseDueDate) <=
            new Date().setMonth(new Date().getMonth() + 1)
        ) {
          return "col-red";
        } else if (row.age === 26) {
          return "col-orange";
        }
      }
      //身份证
      if (column.property === "idCardDueDate") {
        if (
          row.idCardDueDate &&
          this.$XEUtils.timestamp(row.idCardDueDate) <=
            new Date().setMonth(new Date().getMonth() + 1)
        ) {
          return "col-red";
        }
      }
    },
    // 翻译审核状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    }
  }
};
</script>

<style scoped></style>
